// Generated by Melange

import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function ClientsConclusionsMobile(Props) {
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const homePage = match[0].homePage;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("img", {
        src: StaticAsset.src("/static/icons/target.svg")
      }),
      JsxRuntime.jsx("h6", {
        children: homePage.last_feature_title_1,
        className: "h6 text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: homePage.last_feature_text_1,
        className: "paragraph text-gray-landing mt-2"
      }),
      JsxRuntime.jsxs("a", {
        children: [
          Buhta_landing__I18n.trans(intl, "read_all_about_buhta_products"),
          JsxRuntime.jsx("img", {
            className: "inline ml-1",
            src: StaticAsset.src("/static/icons/forward-gray.svg")
          }),
          JsxRuntime.jsx("img", {
            className: "inline ml-1",
            src: StaticAsset.src("/static/icons/soon.svg")
          })
        ],
        className: "block paragraph cursor-pointer mt-4 text-gray-light-landing"
      }),
      JsxRuntime.jsx("img", {
        className: "mt-8",
        src: StaticAsset.src("/static/icons/checks.svg")
      }),
      JsxRuntime.jsx("h6", {
        children: homePage.last_feature_title_2,
        className: "h6 text-black-landing mt-4"
      }),
      JsxRuntime.jsx("p", {
        children: homePage.last_feature_text_2,
        className: "paragraph text-gray-landing mt-2"
      }),
      JsxRuntime.jsxs("a", {
        children: [
          Buhta_landing__I18n.trans(intl, "fully_learn_about_process"),
          JsxRuntime.jsx("img", {
            className: "inline ml-1",
            src: StaticAsset.src("/static/icons/forward-gray.svg")
          }),
          JsxRuntime.jsx("img", {
            className: "inline ml-1",
            src: StaticAsset.src("/static/icons/soon.svg")
          })
        ],
        className: "block paragraph cursor-pointer mt-4 text-gray-light-landing"
      })
    ],
    className: "py-10 px-6 sm:px-48"
  });
}

const make = ClientsConclusionsMobile;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
